module.exports = __webpack_public_path__ + "img/params.e03c9d3f.png";